import { appGraphemeMeaningCardTable } from "@-/dev.improve.haniverse.database.schemas.content.schema._tables.app-grapheme-meaning-card";
import {
  contentTable,
  integer,
  text,
  uniqueIndex,
} from "@-/dev.improve.haniverse.lib.database.table";

export const appGraphemeMeaningCardDescriptionTable = contentTable(
  "app_grapheme_meaning_card_description",
  {
    appGraphemeMeaningCardId: integer("app_grapheme_meaning_card_id")
      .notNull()
      .references(() => appGraphemeMeaningCardTable.id),
    description: text("description").notNull(),
    // The default is required for additive D1 migrations: existing description rows predate
    // this column, and SQLite cannot add a NOT NULL column unless it can backfill those rows.
    mnemonic: text("mnemonic").notNull().default(""),
  },
  (table) => [
    uniqueIndex("app_grapheme_meaning_card_description_meaning_card_id_unique_idx").on(
      table.appGraphemeMeaningCardId,
    ),
  ],
);

export type AppGraphemeMeaningCardDescription =
  typeof appGraphemeMeaningCardDescriptionTable.$inferSelect;
